import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { CustomerObjectQuery, getCustomerQuery } from "../query/customer.query";
import { SiteGroupObjectQuery, getSiteGroups, SiteGroupsForCustomerQuery } from "../query/siteGroup.query";
import { GET_BRANCHES, GetBranchObject } from "../query/branch.query";
import { getSitesQuery } from "../query/site.query";
import { getAgencies } from "../query/agency.query";
import { GetEmployeeRecord } from "../query/employee.query";
import { Form, Input, Select, Spin, Tag } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExternalLinkAlt, faSearch } from "@fortawesome/free-solid-svg-icons";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { CustomerFormDrawer } from "../../pages/customer/customerFormDrawer";
import { AddCustomerMutation } from "../mutation/customer.mutation";
import { useDispatch } from "react-redux";
import { setNotification } from "@src/middleware/redux/reducers/notification.reducer";
import { SitegroupFormDrawer } from "@src/pages/sitegroup/sitegroupFormDrawer";
import { AddSiteGroupMutation } from "../mutation/siteGroup.mutation";
import { FormDrawer } from '@src/pages/formDrawer';
import { objectType } from "../types/object.types";
import { CREATE_BRACNH } from '@src/util/mutation/branch.mutation';
import { LoadingOutlined } from "@ant-design/icons";
import { getZonesQuery } from "../query/zone.query";
import debounce from "lodash/debounce";

// customerId + filterByCustomer: a Site Group field that only lists the chosen customer's site
// groups (site form) - hidden until a customer is picked, and picked for you when there's one.
// hint: a line of explanation under the field.
export const CreateFormLookUpFields = ({setBtn, setGroupInput, tags, setTags, property, value, name, handelDataValue, checkMandatoryField, visible, employee=false, disabled=false, requiredBadge=false, customerId=null, filterByCustomer=false, hint=null})=>{

    const [branchSearch, setBranchSearch] = useState('');
    const [customerSearch, setCustomerSearch] = useState('');
    const [siteGroupSearch, setSiteGroupSearch] = useState('');
    const [agencySearch, setAgencySearch] = useState('');
    const [siteSearch, setSiteSearch] = useState('');
    const [employeeSearch, setEmployeeSearch] = useState('');

    // BranchList
  const { data: branchData, refetch: branchRefetch} = useQuery(GET_BRANCHES ,{
    fetchPolicy: 'cache-and-network',
    variables: {
        input: {
            filters: null,
            search: branchSearch
        }
    }
  });


  // customer list if needed to load
  const {data: customerData, loading: customerLoading, refetch: customerRefetch} = useQuery(getCustomerQuery,{
    variables: {
        input: {
            filters: null,
            search: customerSearch
        }
    },
    fetchPolicy:'network-only'
  });
  // site list if needed to load

  // siteGroup list if needed to load
  const {data: siteGroupData, loading: siteGroupLoading, refetch: siteGroupDataRefetch} = useQuery(getSiteGroups,{fetchPolicy: 'cache-and-network',
        variables: {
            input: {
                filters: null,
                search: siteGroupSearch
            }
        }
  });

  // the chosen customer's site groups (site form)
  const isSiteGroupField = property?.propertyDetail?.fieldType?.toLowerCase()?.replaceAll(" ","")=="sitegroup";
  const {data: customerSiteGroupData, loading: customerSiteGroupLoading, refetch: customerSiteGroupRefetch} = useQuery(SiteGroupsForCustomerQuery, {
    variables: {customerId},
    skip: !filterByCustomer || !isSiteGroupField || !customerId,
    fetchPolicy: 'network-only',
  });
  const customerSiteGroups = customerSiteGroupData?.siteGroupsForCustomer?.response;
  const customerSiteGroupKey = (customerSiteGroups || []).map((sg)=>sg?._id).join(",");

  // a site group from another customer never stays picked; the only one there is gets picked
  useEffect(()=>{
    if(!filterByCustomer || !isSiteGroupField || !customerId || customerSiteGroupLoading || !customerSiteGroups) return;
    const stillValid = value && customerSiteGroups.some((sg)=>sg?._id==value);
    if(stillValid) return;
    const next = customerSiteGroups.length===1 ? customerSiteGroups[0]?._id : "";
    if((value || "") !== next){
      handelDataValue({name, value: next});
      checkMandatoryField && checkMandatoryField();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[filterByCustomer, customerId, customerSiteGroupKey, customerSiteGroupLoading, value]);

  // Agency list if needed to load

    const {data: agencyData, loading: agencyLoading, refetch} = useQuery(getAgencies,{fetchPolicy: 'cache-and-network',
        variables: {
            input: {
                filters: null,
                search: agencySearch
            }
        }
    });


    // branch data configuration
    
  useEffect(()=>{
    if(branchData?.branches?.branches?.length>0){
        setLocalGroup(branchData?.branches?.branches);
    }
  },[branchData?.branches?.branches]);

//   site list

    const {data: siteData, loading: siteLoading} = useQuery(getSitesQuery,{fetchPolicy: 'cache-and-network',
        variables: {
            input: {
                filters: null,
                search: siteSearch
            }
        }
    });

    // employee lookup

    const {data: employeeData, loading: employeeDataLoading} = useQuery(GetEmployeeRecord,{fetchPolicy: 'cache-and-network',
        variables: {
            input: {
                filters: null,
                search: employeeSearch
            }
        }
    });



    const [getZones, { data: zoneData, loading: zoneDataLoading }] =
    useLazyQuery(getZonesQuery, {
      fetchPolicy: "cache-and-network",
    });

  
    // Debounced function
    const debouncedZoneSearch = useMemo(
        () =>
        debounce((value) => {
            getZones({
                variables: {
                    search: value
                },
                fetchPolicy: 'network-only',
                skipPollAttempt: !value || value?.length==0
            });
        }, 250), // 250ms delay
        [getZones]
    );
    
    // handler passed to Select
    const handleZoneSearch = useCallback(
        (value) => {
            if(value){
                debouncedZoneSearch(value);
            }
        },
        [debouncedZoneSearch]
    );
    
    // cleanup (important!)
    useEffect(() => {
        return () => {
        debouncedZoneSearch.cancel();
        };
    }, [debouncedZoneSearch]);

    const debouncedBranchSearch = useMemo(() => debounce((val) => setBranchSearch(val), 300), []);
    const debouncedCustomerSearch = useMemo(() => debounce((val) => setCustomerSearch(val), 300), []);
    const debouncedSiteGroupSearch = useMemo(() => debounce((val) => setSiteGroupSearch(val), 300), []);
    const debouncedAgencySearch = useMemo(() => debounce((val) => setAgencySearch(val), 300), []);
    const debouncedSiteSearch = useMemo(() => debounce((val) => setSiteSearch(val), 300), []);
    const debouncedEmployeeSearch = useMemo(() => debounce((val) => setEmployeeSearch(val), 300), []);

    useEffect(() => {
        return () => {
            debouncedBranchSearch.cancel();
            debouncedCustomerSearch.cancel();
            debouncedSiteGroupSearch.cancel();
            debouncedAgencySearch.cancel();
            debouncedSiteSearch.cancel();
            debouncedEmployeeSearch.cancel();
        };
    }, [debouncedBranchSearch, debouncedCustomerSearch, debouncedSiteGroupSearch, debouncedAgencySearch, debouncedSiteSearch, debouncedEmployeeSearch]);


  
  
  
  const popoverRef = useRef(null);
  const inputRef = useRef(null);
  const [groupPopover, setGroupPopover] = useState(false);
  const [parentWidth, setParentWidth] = useState(null);
  const parentRef = useRef(null);
  
  // set tags empty when drawer visibility change

  useEffect(()=>{
    setTags([]);
  },[visible]);

  const [localGroup, setLocalGroup] = useState(branchData?.branches?.branches||[]);
  useEffect(() => {
    const updateParentWidth = () => {
      if (parentRef.current) {
        const width = parentRef.current.offsetWidth;
        setParentWidth(width);
      }
    };

    // Call the update function on initial mount and window resize
    updateParentWidth();
    window.addEventListener('resize', updateParentWidth);
    inputRef?.current?.focus();

    // Clean up the event listener on unmount
    return () => {
      window.removeEventListener('resize', updateParentWidth);
    };

  }, [groupPopover, visible]);


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.group-wrapper')) {
        setGroupPopover(false);
      }
    };

    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const {Option} = Select;

  const [data, setData] = useState([]);
  const [isBtnEnable, setBtnEnable] = useState(true);
  const [isoverlay, setIsOverlay] = useState(true);
  const dispatch = useDispatch();
  
// =================================================
// ========================= customer add new
// =================================================

  const [customerModal, setCustomerModal] = useState(false);
  const {data:customerObject, loading: customerObjectLoading, refetch: customerObjectRefetch} = useQuery(CustomerObjectQuery);
  const [addCustomerMutation, {loading: processloading}] = useMutation(AddCustomerMutation);
  
    const customerMutation = async (customer) =>{
    try{
        await addCustomerMutation({variables: {input: customer}});
        await customerObjectRefetch();
        await refetch();

        dispatch(setNotification({
            notificationState:true, 
            message: "Customer was added successfully",
            error: false,
        }));
        setData([]);
        setBtnEnable(true);
        setIsOverlay(true);

    }catch(err){
        dispatch(setNotification({
            notificationState: true,
            error: true,
            message: err?.message
        }));
    }
    }

    const handelSubmit = async (isCloseAble)=>{
        const customername = data?.find((d)=>(Object.keys(d)[0]=="customername"));
        // the customer's branch is its own field, not metadata (see customer.page.jsx)
        const branchField = customerObject?.getCustomerObject?.response?.find((p)=>p?.propertyDetail?.fieldType==="branch")?.propertyDetail?.label?.replaceAll(" ","").toLowerCase();
        const branch = branchField ? data?.find((d)=>Object.keys(d)[0]==branchField)?.[branchField] : undefined;
    
        let metadata = {};
        data?.map(d=>{
        if(Object.keys(d)[0]!=="customername" && Object.keys(d)[0]!==branchField){
            metadata[Object.keys(d)[0]]= Object.values(d)[0]
        }
        });
        const customerData = {
        ...customername,
        ...(branch ? {branch} : {}),
        metadata,
        }
        // handel mutation
        await customerMutation(customerData);

        if(isCloseAble){
            setCustomerModal(!customerModal);
        }

    };

// =================================================
// ========================= sitegroup add new
// =================================================
    const [siteGroupModal, setSiteGroupModal] = useState(false);
    const {data:siteGroupObject, loading: siteGroupObjectLoading, refetch: siteGroupObjectRefetch} = useQuery(SiteGroupObjectQuery);
    const [addSiteGroupMutation, {loading: siteGroupMutationLoading}] = useMutation(AddSiteGroupMutation);
    
    
    const siteGroupMutation = async (siteGroup) =>{
        try{
            await addSiteGroupMutation({variables: {input: siteGroup}});
            await siteGroupObjectRefetch();
            await siteGroupDataRefetch();
            if(filterByCustomer && customerId) await customerSiteGroupRefetch();

            dispatch(setNotification({
                notificationState:true, 
                message: "Site group was added successfully",
                error: false,
            }));
            setData([]);
            setBtn(true);
            setIsOverlay(true);

        }catch(err){
            dispatch(setNotification({
                notificationState: true,
                error: true,
                message: err?.message
            }));
        }
    }

    const handelSubmitSiteGroup =  async (isCloseAble)=>{
        const sitegroupname = data?.find((d)=>(Object.keys(d)[0]=="sitegroupname"));
        const branch = data?.find((d)=>(Object.keys(d)[0]=="branch"));
        const customer = data?.find((d)=>(Object.keys(d)[0]=="customer"));
       
        let metadata = {};
        data?.map(d=>{
          if(Object.keys(d)[0]!=="sitegroupname" && Object.keys(d)[0]!=="branch" && Object.keys(d)[0]!=="customer" ){
            metadata[Object.keys(d)[0]]= Object.values(d)[0]
          }
        });
        const siteGroupData = {
          ...sitegroupname,
          ...branch,
          ...customer,
          metadata,
        }
        // handel mutation
        await siteGroupMutation(siteGroupData);

        if(isCloseAble){
            setSiteGroupModal(!siteGroupModal);
        }

    };


    // =========================================================
    // ================== Branch new add
    // =========================================================
    const [branchModal, setBranchModal] = useState(false);

    const {data:branchObjectData, loading: branchObjectLoading, refetch: schemaRefetch} = useQuery(GetBranchObject,{
        fetchPolicy:'cache-and-network'
    });

    const [createBranch, { loading:processLoading }] = useMutation(CREATE_BRACNH);

    const branchMutation=async (branch)=>{
        try{
          await createBranch({variables: {input: branch}});
          dispatch(setNotification({
            notificationState:true, 
            message: "Branch was added successfully",
            error: false,
          }))
          setData([]);
          setBtn(true);
          setIsOverlay(true);
          await branchRefetch();
    
        }
        catch(err){
          dispatch(setNotification({
              message: err?.message,
              error: true,
              notificationState: true
            }));
          
        }
    }

    const handelBranchSubmit=async (isCloseAble)=>{
        const branchName = data?.find((d)=>(Object.keys(d)[0]=="branchname"));
        const postcode = data?.find((d)=>(Object.keys(d)[0]==="postcode"));
        
        let metadata = {};
        data?.map(d=>{
          if(Object.keys(d)[0]!=="postcode" && Object.keys(d)[0]!=="branchname"){
            metadata[Object.keys(d)[0]]= Object.values(d)[0]
          }
        });
        const branch = {
          ...branchName,
          ...postcode,
          metadata,
        }
        // handel mutation
        await branchMutation(branch);

        if(isCloseAble){
            setBranchModal(!branchModal);
        }

    }


    return (
            

        // pre define system fields
        property?.propertyDetail?.fieldType.toLowerCase()=="branch"?
        // multi branch is required in employees only
        employee?
        <Form.Item>
            <label>{tags?.length>1? 'Branches': 'Branch'} {property?.isMandatory? (requiredBadge? <span className='required-badge-inline'>Required</span> : <sup className='mandatory'>*</sup>) : null} </label>
            
            {tags?.length>0?
            <>
                
                <div className="grouptabs" style={{marginBottom: '16px'}}>
                    {tags?.map((property)=>(
                        <Tag closable={true} onClose={()=>{setBtn(true); setGroupInput({id:"dumy"}); setTags(tags?.filter((tag)=>tag.id!=property.id));  }} className='tag'>
                            {property.name}
                        </Tag>
                    ))}
                </div>
            </>
            : null
            }
            <div className="group-wrapper">
                <div
                    name="groupInput"
                    className='generic-input-control groupInput' 
                    style={{cursor:'pointer', padding:'0 0px'}}
                    onClick={()=>setGroupPopover(!groupPopover)}
                >
                    <div  style={{fontSize:'14px', fontWeight: 'normal', margin: '9px', display: 'flex'}}>
                        Select branch
                        <span onClick={disabled?()=>{} :()=>setGroupPopover(!groupPopover)} 
                            style={{
                                position: 'absolute',
                                right: '6px',
                            }} className='caret'></span>
                    </div>
                </div>

                <div ref={parentRef} id="branch-selector" className={groupPopover? 'show ': 'hide'} >
                    <div className="moveGroupData" style={{width: parentWidth-1.5, position:'absolute', zIndex:9}} >
                        <div className="popover-search" >
                            <Input type="search" 
                                ref={inputRef}
                                name='popoverSearch'
                                style={{ width: '-webkit-fill-available', backgroundColor: 'white'  }} 
                                className='generic-input-control' 
                                placeholder="Search..."
                                autoFocus={groupPopover}
                                autoComplete="off"
                                onChange={(e)=> setLocalGroup(branchData?.branches?.branches?.filter((group)=> (group.branchname)?.toLowerCase()?.includes(e.target.value?.toLowerCase())))}
                                suffix={<FontAwesomeIcon style={{color:'#0091ae'}}  icon={faSearch}/>}
                            />
                        </div>

                        <div ref={popoverRef}>
                            {localGroup?.length ? localGroup?.map((gl)=>(
                                <div 
                                    className={"popoverdataitem"} 
                                    onClick={(e)=>{setGroupInput({name:gl.branchname, id:gl._id}); setBtn(true); setGroupPopover(false)}}>
                                    {gl.branchname}
                                </div>
                            )):
                            
                            <div 
                                className={"popoverdataitem"} 
                                style={{cursor:'no-drop'}}
                                onClick={(e)=>{ setGroupPopover(false)}}>
                                No results found
                            </div>
                            }
                        </div>
                    </div>

                </div>
            
                    
                    
                
            </div>
        </Form.Item>
        :
        
        <Form.Item>
            <label>{property?.propertyDetail?.label}  {property?.isMandatory? (requiredBadge? <span className='required-badge-inline'>Required</span> : <sup className='mandatory'>*</sup>) : null} </label>
            <Select
                showSearch
                filterOption={false}
                onSearch={debouncedBranchSearch}
                disabled={disabled}
                className='custom-select'
                suffixIcon={<span className='dropdowncaret'></span>}
                name={name}
                id={name}
                value={value}
                placeholder="Select Branch"
                onChange={(e)=>{handelDataValue({
                name,
                value: e
                });checkMandatoryField()}}

            >
                <Option value="default" disabled style={{fontWeight:'bold', color:'#0091ae', cursor:'pointer'}}>
                    <span onClick={()=>setBranchModal(true)}>
                        Create new branch <FontAwesomeIcon icon={faExternalLinkAlt} /> 
                    </span>
                </Option>

                {branchData?.branches?.branches?.map((option)=>(<Option value={option._id}> {option?.branchname} </Option>))}
            </Select>
            {hint && <div className='form-field-hint'>{hint}</div>}
            
            
            <FormDrawer
                objectData={branchObjectData?.getBranchProperty?.response}
                objectLoading={branchObjectLoading}
                handelSubmit={handelBranchSubmit}
                visible={branchModal} 
                refetch={branchRefetch} 
                setBtn={setBtnEnable}
                data={data}
                setData={setData}
                isBtnEnable={isBtnEnable}
                isoverlay={isoverlay}
                setIsOverlay={setIsOverlay}
                loading={processLoading}
                onClose={()=>setBranchModal(!branchModal)} 
                to={"/branch/editform"}
                from={"/user/branch"}
                title={objectType.Branch}
            />

        </Form.Item> 

        :                        
        property?.propertyDetail?.fieldType.toLowerCase()=="customer"?
            
            <Form.Item>
                <label>{property?.propertyDetail?.label}  {property?.isMandatory? (requiredBadge? <span className='required-badge-inline'>Required</span> : <sup className='mandatory'>*</sup>) : null} </label>
                    <Select
                        showSearch
                        filterOption={false}
                        onSearch={debouncedCustomerSearch}
                        disabled={disabled}
                        className='custom-select'
                        suffixIcon={<span className='dropdowncaret'></span>}
                        name={name}
                        id={name}
                        value={value}
                        placeholder="Select Customer"
                        onChange={(e)=>{
                                handelDataValue({
                                    name,
                                    value: e
                                });checkMandatoryField();

                        }}

                    >
                        <Option value="default" disabled
                        style={{fontWeight:'bold', color:'#0091ae', cursor:'pointer'}}>
                            <span onClick={()=>setCustomerModal(true)}>
                                Create new customer <FontAwesomeIcon icon={faExternalLinkAlt} /> 
                            </span>
                        </Option>

                        {customerData?.customers?.customers?.map((option)=>(<Option value={option._id}> {option?.customername} </Option>))}
                    </Select>

                    <CustomerFormDrawer            
                        objectData={customerObject?.getCustomerObject?.response}
                        objectLoading={customerObjectLoading}
                        handelSubmit={async() => {
                        await handelSubmit();  await customerRefetch();  
                        handelDataValue({
                            name,
                            value: ''
                        }); 
                        setCustomerModal(false); 
                        
                        }}
                        visible={customerModal} 
                        refetch={customerRefetch} 
                        setBtn={setBtnEnable}
                        data={data}
                        setData={setData}
                        isBtnEnable={isBtnEnable}
                        isoverlay={isoverlay}
                        setIsOverlay={setIsOverlay}
                        loading={processloading}
                        onClose={async()=>{
                            handelDataValue({
                                name,
                                value: ''
                            })
                            await customerRefetch();
                            setCustomerModal(false); 
                        }} 
                        to={"/branch/editform"}
                        from={"/user/branch"}
                        title={"Customer"}
                    />

            </Form.Item>  

        :
    
        property?.propertyDetail?.fieldType.toLowerCase().replaceAll(" ","")=="sitegroup"?

        // on the site form the site group comes after the customer - nothing to pick until then
        filterByCustomer && !customerId ? null :
            
        <Form.Item>
            <label>{property?.propertyDetail?.label}  {property?.isMandatory? (requiredBadge? <span className='required-badge-inline'>Required</span> : <sup className='mandatory'>*</sup>) : null} </label>
                <Select
                showSearch
                filterOption={filterByCustomer ? (input, option)=> String(option?.label ?? "").toLowerCase().includes(String(input).toLowerCase()) : false}
                onSearch={filterByCustomer ? undefined : debouncedSiteGroupSearch}
                disabled={disabled}
                loading={filterByCustomer && customerSiteGroupLoading}
                    className='custom-select'
                    suffixIcon={<span className='dropdowncaret'></span>}
                    name={name}
                    id={name}
                    value={value || undefined}
                    placeholder="Select site group"
                    onChange={(e)=>{
                        handelDataValue({
                        name,
                        value: e
                        });checkMandatoryField();

                    }}

                >
                    <Option value="default" label="" disabled style={{fontWeight:'bold', color:'#0091ae', cursor:'pointer'}}>
                        <span onClick={()=>{
                            // a site group made from here is for the customer already picked
                            if(filterByCustomer && customerId) setData([{customer: customerId}]);
                            setSiteGroupModal(true);
                        }}>
                            Create new site group <FontAwesomeIcon icon={faExternalLinkAlt} /> 
                        </span>
                    </Option>
                    {(filterByCustomer ? customerSiteGroups : siteGroupData?.sitegroups?.sitegroups)?.map((option)=>(<Option key={option._id} value={option._id} label={option?.sitegroupname}> {option?.sitegroupname} </Option>))}
                </Select>
                {filterByCustomer && customerSiteGroups && customerSiteGroups.length===0 &&
                    <div className='form-field-hint'>This customer has no site groups yet - create one from the list.</div>
                }
                {hint && <div className='form-field-hint'>{hint}</div>}
                
                <SitegroupFormDrawer
                    objectData={siteGroupObject?.getSiteGroupObject?.response}
                    objectLoading={siteGroupObjectLoading}
                    handelSubmit={handelSubmitSiteGroup}
                    visible={siteGroupModal} 
                    refetch={siteGroupDataRefetch} 
                    setBtn={setBtnEnable}
                    data={data}
                    setData={setData}
                    isBtnEnable={isBtnEnable}
                    isoverlay={isoverlay}
                    setIsOverlay={setIsOverlay}
                    loading={siteGroupMutationLoading}
                    onClose={()=>setSiteGroupModal(!siteGroupModal)} 
                    to={"/branch/editform"}
                    from={"/user/branch"}
                    title={"Site Group"}
                />

        </Form.Item> 
        
        :
        
        property?.propertyDetail?.fieldType.toLowerCase().replaceAll(" ","")=="site"?
            
        <Form.Item>
            <label>{property?.propertyDetail?.label}  {property?.isMandatory? (requiredBadge? <span className='required-badge-inline'>Required</span> : <sup className='mandatory'>*</sup>) : null} </label>
                <Select
                    showSearch
                    filterOption={false}
                    onSearch={debouncedSiteSearch}
                    disabled={disabled}
                    className={disabled?'custom-select disabled-select' :'custom-select'}
                    suffixIcon={<span className='dropdowncaret'></span>}
                    name={name}
                    id={name}
                    value={value}
                    placeholder="Select site"
                    onChange={(e)=>{handelDataValue({
                    name,
                    value: e
                    });checkMandatoryField()}}
                >
                    {siteData?.sites?.sites?.map((option)=>(<Option value={option._id}> {option?.sitename} </Option>))}
                </Select>
        </Form.Item> 

        : property?.propertyDetail?.fieldType.toLowerCase().replaceAll(" ","")=="agency"?
                
        <Form.Item>
        <label>{property?.propertyDetail?.label}  {property?.isMandatory? (requiredBadge? <span className='required-badge-inline'>Required</span> : <sup className='mandatory'>*</sup>) : null} </label>
            <Select
                showSearch
                filterOption={false}
                onSearch={debouncedAgencySearch}
                disabled={disabled}
                className='custom-select'
                suffixIcon={<span className='dropdowncaret'></span>}
                name={name}
                id={name}
                value={value}
                placeholder="Select supplier"
                onChange={(e)=>{handelDataValue({
                name,
                value: e
                });checkMandatoryField()}}

            >
                {agencyData?.agencies?.agencies?.map((option)=>(<Option value={option._id}> {option?.suppliername} </Option>))}
            </Select>
        </Form.Item> 

        : property?.propertyDetail?.fieldType.toLowerCase().replaceAll(" ","")=="employee"?
        
        <Form.Item>
        <label>{property?.propertyDetail?.label}  {property?.isMandatory? (requiredBadge? <span className='required-badge-inline'>Required</span> : <sup className='mandatory'>*</sup>) : null} </label>
            <Select
            showSearch
            filterOption={false}
            onSearch={debouncedEmployeeSearch}
                loading={employeeDataLoading}
                className='custom-select'
                suffixIcon={employeeDataLoading? <Spin indicator={<LoadingOutlined />} /> :<span className='dropdowncaret'></span>}
                name={name}
                id={name}
                value={value}
                placeholder="Select Employee"
                onChange={(e)=>{handelDataValue({
                name,
                value: e
                });checkMandatoryField()}}

            >
                
                {
                    !employeeDataLoading?
                        employeeData?.getEmployee?.response?.map((option)=>(<Option value={option._id}> {option?.firstname +" "+option?.lastname} </Option>))
                    :
                        <Option hidden disabled>Loading ...</Option>
                }
            </Select>
        </Form.Item> 

        : property?.propertyDetail?.fieldType.toLowerCase().replaceAll(" ","")=="zone"?

        <Form.Item>
            <label>{property?.propertyDetail?.label}  {property?.isMandatory? (requiredBadge? <span className='required-badge-inline'>Required</span> : <sup className='mandatory'>*</sup>) : null} </label>
            <Select 
                showSearch
                filterOption={false} 
                onSearch={handleZoneSearch}
                loading={zoneDataLoading}
                className='custom-select'
                suffixIcon={
                    zoneDataLoading
                        ? <Spin indicator={<LoadingOutlined />} />
                        : <span className='dropdowncaret'></span>
                }
                name={name}
                id={name}
                value={value}
                placeholder="Select Zone"
                onChange={(e)=>{
                    handelDataValue({
                        name,
                        value: e
                    });
                    checkMandatoryField();
                }}
            >
                
                {
                    !zoneDataLoading?
                        zoneData?.getZones?.response?.map((option)=>(<Option value={option._id}> {option?.name} </Option>))
                    :
                        <Option hidden disabled>Loading ...</Option>
                }
            </Select>
        </Form.Item> 
        : null

    )
}


// single branch

         
// <Form.Item>
//     <label>{property?.propertyDetail?.label}  {property?.isMandatory? (requiredBadge? <span className='required-badge-inline'>Required</span> : <sup className='mandatory'>*</sup>) : null} </label>
//         <Select 
//           className='custom-select'  
//           suffixIcon={<span className='dropdowncaret'></span>}
//           name={name}
//           id={name}
//           value={value}
//           placeholder="Select Branch"
//           onChange={(e)=>{handelDataValue({
//             name,
//             value: e
//           });checkMandatoryField()}}

//         >
//             {branchData?.branches?.branches?.map((option)=>(<Option value={option._id}> {option?.branchname} </Option>))}
//         </Select>
// </Form.Item>  